import {Injectable, Inject} from 'ng-metadata/core';
import {getInstitutionCode} from '../../appConfig/appConfigForward';


const orderBy= require('lodash/orderBy');

interface InstitutionValue {
    institutionCode:string;
    patronId:string;
}

interface Institution {
    label:string;
    value:InstitutionValue;
}

@Injectable()
export class LinkedUserSelectorService {

    private _institutionsList: Institution[];
    private _selectedInstitution: InstitutionValue;

    constructor() {
    }

     public setInstitutionsList(response){
        if(this._institutionsList){
            return;
        }
        try{
            let accountList= response.data.accountslist.account;
            this._institutionsList= orderBy(accountList.map((account)=>{return {label:(account.primoinstitution ? account.primoinstitution : account.institutioncode), value:{institutionCode:account.institutioncode, patronId: account.useridentifier}}}),(account)=>account.value.institutionCode, 'asc');
        }
        catch(err){
        }
        this.setInitialInstitution();
    }

    private setInitialInstitution(){
        let loginInstCode= getInstitutionCode();
        this._selectedInstitution= this._institutionsList.filter((inst)=>inst.label===loginInstCode)[0].value;
    }

    get institutionsList(){
        return this._institutionsList;
    }

    get selectedInstitution(){
        return this._selectedInstitution;
    }

    set selectedInstitution(inst){
        this._selectedInstitution= inst;
    }


}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/account/linkedUserSelector/linkedUserSelector.service.ts